var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticStyle:{"margin-top":"20px"},attrs:{"shadow":"always","body-style":{ padding: '20px' }}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"md":24,"offset":0}},[_c('nuevo-cat')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }